module.exports = __webpack_public_path__ + "0aa2d7c726eb523de75244904fec1ed3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-orange-s.png
// module id = 2224
// module chunks = 0